import { types } from "./types";
import ConvertDateToString from "./ConvertDateToString/ConvertDateToString";
import ModifyDate from "./ModifyDate/ModifyDate";

function Actions(
  action,
  showAlert,
  variables,
  setOpenVariable,
  variableRender
) {
  switch (action.actionName) {
    case types.CONVERTDATETOSTRING:
      return (
        <ConvertDateToString
          action={action}
          variables={variables}
          setOpenVariable={setOpenVariable}
          variableRender={variableRender}
        />
      );
    case types.MODIFYDATE:
      return (
        <ModifyDate
          action={action}
          variables={variables}
          setOpenVariable={setOpenVariable}
          variableRender={variableRender}
        />
      );
    default: break;
  }
}

export default Actions;
